import { ArrowRightOutlined } from '@ant-design/icons'
import { Button, Checkbox, Dropdown, Empty } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { FC, useState } from 'react'
import styled from 'styled-components'
import useErrorModal from '../../../../../../../hooks/api/use-error-modal'
import useSuccessModal from '../../../../../../../hooks/api/use-success-modal'
import { useDistributeRewindJobMutation } from '../../../../../../../store/api/rewind-jobs-api'
import { rewindQueueEntriesApi } from '../../../../../../../store/api/rewind-queue-entries-api'
import { useAppDispatch } from '../../../../../../../store/store'
import Machine from '../../../../../../../types/api/machine'
import RewindJob from '../../../../../../../types/api/rewind-job'

const DropdownContent = styled.div`
    min-width: 180px;
    padding: 8px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colorBgElevated};
    box-shadow: ${({ theme }) => theme.boxShadowSecondary};
`

const MachineCheckbox = styled.div`
    margin-bottom: 6px;
`

interface AddToMachineQueueProps {
    rewindJob: RewindJob
    machines: Machine[]
}

const AddToMachineQueue: FC<AddToMachineQueueProps> = ({ rewindJob, machines }) => {
    const dispatch = useAppDispatch()
    const [selected, setSelected] = useState<Machine[]>([])
    const [distributeRewindJob, distributeRewindJobState] = useDistributeRewindJobMutation()

    useErrorModal(distributeRewindJobState, 'Ошибка размещения задания перемотки')
    useSuccessModal(distributeRewindJobState, 'Задание добавлено в очередь перемотки')

    const onCheckboxChange = (e: CheckboxChangeEvent, machine: Machine) => {
        setSelected(prev =>
            e.target.checked
                ? [...prev, machine]
                : prev.filter(item => item.documentId !== machine.documentId)
        )
    }

    const onConfirm = async () => {
        const result = await distributeRewindJob({
            docId: rewindJob.documentId,
            machines: selected.map(machine => machine.documentId),
        })

        if ('data' in result) {
            dispatch(rewindQueueEntriesApi.util.invalidateTags(['RewindQueueEntries']))
            setSelected([])
        }
    }

    return (
        <Dropdown
            trigger={['hover']}
            dropdownRender={() => (
                <DropdownContent>
                    {machines.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    {[...machines]
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map(machine => (
                            <MachineCheckbox key={machine.documentId}>
                                <Checkbox
                                    checked={selected.some(item => item.documentId === machine.documentId)}
                                    onChange={event => onCheckboxChange(event, machine)}
                                >
                                    {machine.name}
                                </Checkbox>
                            </MachineCheckbox>
                        ))}
                    <Button
                        type='primary'
                        icon={<ArrowRightOutlined />}
                        iconPosition='end'
                        loading={distributeRewindJobState.isLoading}
                        disabled={selected.length === 0}
                        onClick={onConfirm}
                    >
                        Разместить
                    </Button>
                </DropdownContent>
            )}
        >
            <Button size='small' icon={<ArrowRightOutlined />} type='primary' />
        </Dropdown>
    )
}

export default AddToMachineQueue